import { withLocalCharacters } from "../../../../Utils/localCharacters";
import { findTalkingCharacters } from "../../../../Utils/talkingCharacters";
import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import swal from "sweetalert";
import AuthContext from "../../../../context/userAuth.context";
import Lottie from "react-lottie";
import TickerContext from "../../../../context/ticker";
import MiniCanv from "./MiniCanv";
import StaticCharacter from "./StaticCharacter";
import loader from "../../../../assets/Loader/AssetLoader.json";

const AssetsCharacterWrapper = ({
  item,
  name,
  indexes,
  path,
  setChrPopData,
  setchrPop,
  id,
  StartClicking,
  CreateStart,
  OpenCategory,
  setOpenCategory,
  ActiveTab
}) => {
  const { charcterFolder, setcharcterFolder,setPremiumActionsArray } = useContext(TickerContext);

  const { authenticationData, Role } = useContext(AuthContext);

  const [ShowItems, setShowItems] = useState(false);

  const [MyLoader, setMyLoader] = useState(false);

  const [staticCharacter, setstaticCharacter] = useState([]);

  const [defaultCharacter, setdefaultCharacter] = useState([]);

  // Talking tab: how many library characters have been checked for a talking mouth.
  const [talkCheck, setTalkCheck] = useState(null); // { checked, total, found }

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const show = () => {
    if (id !== OpenCategory) {
      setOpenCategory(id);
    } else {
      setShowItems(false);
      setOpenCategory(null);
    }
  };

  // Talking tab: this app's own talking characters first, then the library characters whose
  // animation has a talking mouth (checked in the background, see Utils/talkingCharacters.js).
  useEffect(() => {
    if (ActiveTab !== "Talking") return undefined;
    let stop = null;
    let cancelled = false;
    setstaticCharacter([]);
    setdefaultCharacter([]); // the other tabs' lists
    setTalkCheck(null);
    axios
      .get(authenticationData.ApiBaseURL + `/api/Character/GetALLCharahcters`, {
        headers: { Authorization: "Bearer " + authData.access_token },
      })
      .then((response) => {
        if (cancelled) return;
        if (response.data.premium_Actions_ARRAY) setPremiumActionsArray(JSON.parse(response.data.premium_Actions_ARRAY));
        const rows = withLocalCharacters(JSON.parse(response.data.staticChar || "[]"));
        let shown = -1;
        stop = findTalkingCharacters(rows, authenticationData.ApiBaseURL, (talking, progress) => {
          setTalkCheck({ ...progress, found: talking.length });
          if (talking.length !== shown) {
            shown = talking.length;
            setdata(talking.map((r) => ({ ...r })));
          }
        });
      })
      .catch(() => {
        // The library could not be loaded: still show this app's own talking characters.
        if (cancelled) return;
        const local = withLocalCharacters([]);
        setdata(local);
        setTalkCheck({ checked: 0, total: 0, found: local.length });
      });
    return () => {
      cancelled = true;
      if (stop) stop();
    };
  }, [ActiveTab]);

  useEffect(() => {
    if (ActiveTab == "Characters") {
      axios
        .get(authenticationData.ApiBaseURL + `/api/Character/GetALLCharahcters`, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          //console.log(resp onse.data);
          setDefaultData(JSON.parse(response.data.defaultChar), 1);

          setdata(JSON.parse(response.data.staticChar));

          setPremiumActionsArray(JSON.parse(response.data.premium_Actions_ARRAY))

          // setstaticCharacter(JSON.parse(response.data.staticChar));
          // setdefaultCharacter(JSON.parse(response.data.defaultChar));

          // setMyLoader(false);
        })
        .catch((error) => {
          // console.log(error);
          // setMyLoader(false);
        });
    } 
    else if (ActiveTab == "MyCharacters") {
      axios
        .get(authenticationData.ApiBaseURL + `/api/Character/GetUserCharacter`, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          //console.log(response.data);
          setUserCharactersData(response.data.characters,1);

         // setdata(JSON.parse(response.data.characters));

          // setstaticCharacter(JSON.parse(response.data.staticChar));
          // setdefaultCharacter(JSON.parse(response.data.defaultChar));

          // setMyLoader(false);
        })
        .catch((error) => {
          // console.log(error);
          // setMyLoader(false);
        });
    }
  }, [ActiveTab]);


  // useEffect(() => {
  //   if (item.length == 0 && ShowItems) {
  //     setMyLoader(true);
  //     if (id != 0) {
  //       axios
  //         .get(
  //           authenticationData.ApiBaseURL +
  //             `/api/Character/GetStaticCharacters?catId=${id}`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               "Access-Control-Allow-Origin": "*",
  //               Authorization: "Bearer " + authData.access_token,
  //             },
  //           }
  //         )
  //         .then((response) => {
  //           if (id == 1) {
  //             setDefaultData(response.data, 1);
  //           } else {
  //             setdata(response.data);
  //           }
  //           setMyLoader(false);
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           setMyLoader(false);
  //         });
  //     } else {
  //       axios
  //         .get(
  //           authenticationData.ApiBaseURL + "/api/Character/GetUserCharacter",
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               "Access-Control-Allow-Origin": "*",
  //               Authorization: "Bearer " + authData.access_token,
  //             },
  //           }
  //         )
  //         .then((response) => {
  //           setDefaultData(response.data);
  //           setMyLoader(false);
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           setMyLoader(false);
  //         });
  //     }
  //   }
  // }, [ShowItems]);


  // A character deleted from My Characters: drop its card (rows and their items stay in step).
  const removeUserCharacter = (characterId) => {
    setdefaultCharacter((prev) => {
      const items = ((prev[0] && prev[0].items) || []).filter((o) => o && o.id !== characterId);
      return prev.filter((row) => row.id !== characterId).map((row) => ({ ...row, items }));
    });
  };

  const setUserCharactersData = (data,id) => {
    // debugger;
    let state = data;
    let obj = [];

    for (let a = 0; a < data.length; a++) {
      let innerobj = {
        Item_Path: "",
        FilePath: "",
        Name: "",
        FullImg: null,
        MiniImg: null,
        settings: "",
        gender: "",
        poses: [],
        id: "",
      };
      let gestures = JSON.parse(data[a].gesturePaths);
      let gestImg = null;
      if (data[a].svg != null) {
        gestImg = JSON.parse(data[a].svg);
      }

      if (gestures != null) {
        for (let i = 0; i < gestures.length; i++) {
          let Pobj = {
            poseFile: null,
            poseName: null,
            poseLargeImg: null,
            poseSmallImg: null,
          };
          Pobj.poseFile = gestures[i];
          let splitter = gestures[i].split("_");

          if (splitter.length == 2) {
            Pobj.poseName = "Default";
          } else {
            let inSplit = splitter[2].split(".json")[0];
            Pobj.poseName = inSplit;
          }
          if (gestImg) {
            for (const itr of gestImg) {
              if (itr.name == Pobj.poseName) {
                Pobj.poseLargeImg = itr.largeImgPath;
                Pobj.poseSmallImg = itr.smallImagePath;
                break;
              }
            }
          }
          innerobj.poses.push(Pobj);
        }
      } else {
        let Pobj = {
          poseFile: null,
          poseName: null,
          poseLargeImg: null,
          poseSmallImg: null,
        };
        innerobj.poses.push(Pobj);
      }

      if (gestImg) {
        for (const itr of gestImg) {
          if (itr.name == "Default") {
            innerobj.FullImg = itr.largeImgPath;
            innerobj.MiniImg = itr.smallImagePath;
            break;
          }
        }
      }

      innerobj.FilePath = data[a].fileName;
      innerobj.Name = data[a].characterName;
      innerobj.settings = JSON.parse(data[a].partsData);
      innerobj.gender = data[a].gender;
      innerobj.id = data[a].id;
      obj.push(innerobj);
    }

    if (id) {
      for (let i = 0; i < state.length; i++) {
        state[i].items = obj;
      }
      setdefaultCharacter(state);
    } else {
      state[0].items = obj;
      let arr = [];
      for (const itr of obj) {
        if (!itr.MiniImg && !itr.FullImg) {
          arr.push(itr);
        }
      }
      if (arr.length != 0) {
        StartClicking(arr);
      }
      setcharcterFolder(state);
    }
  };

  const setDefaultData = (data, id) => {
    // debugger;
    let state = data;
    let obj = [];

    for (let a = 0; a < data.length; a++) {
      let innerobj = {
        Item_Path: "",
        FilePath: "",
        Name: "",
        FullImg: null,
        MiniImg: null,
        settings: "",
        gender: "",
        poses: [],
        id: "",
      };
      let gestures = JSON.parse(data[a].GesturePaths);
      let gestImg = null;
      if (data[a].svg != null) {
        gestImg = JSON.parse(data[a].svg);
      }

      if (gestures != null) {
        for (let i = 0; i < gestures.length; i++) {
          let Pobj = {
            poseFile: null,
            poseName: null,
            poseLargeImg: null,
            poseSmallImg: null,
          };
          Pobj.poseFile = gestures[i];
          let splitter = gestures[i].split("_");

          if (splitter.length == 2) {
            Pobj.poseName = "Default";
          } else {
            let inSplit = splitter[2].split(".json")[0];
            Pobj.poseName = inSplit;
          }
          if (gestImg) {
            for (const itr of gestImg) {
              if (itr.name == Pobj.poseName) {
                Pobj.poseLargeImg = itr.largeImgPath;
                Pobj.poseSmallImg = itr.smallImagePath;
                break;
              }
            }
          }
          innerobj.poses.push(Pobj);
        }
      } else {
        let Pobj = {
          poseFile: null,
          poseName: null,
          poseLargeImg: null,
          poseSmallImg: null,
        };
        innerobj.poses.push(Pobj);
      }

      if (gestImg) {
        for (const itr of gestImg) {
          if (itr.name == "Default") {
            innerobj.FullImg = itr.largeImgPath;
            innerobj.MiniImg = itr.smallImagePath;
            break;
          }
        }
      }

      innerobj.FilePath = data[a].FileName;
      innerobj.Name = data[a].CharacterName;
      innerobj.settings = JSON.parse(data[a].PartsData);
      innerobj.gender = data[a].Gender;
      innerobj.id = data[a].Id;
      obj.push(innerobj);
    }

    if (id) {
      for (let i = 0; i < state.length; i++) {
        state[i].items = obj;
      }
      setdefaultCharacter(state);
    } else {
      state[0].items = obj;
      let arr = [];
      for (const itr of obj) {
        if (!itr.MiniImg && !itr.FullImg) {
          arr.push(itr);
        }
      }
      if (arr.length != 0) {
        StartClicking(arr);
      }
      setcharcterFolder(state);
    }
  };

  const setdata = (data) => {
    // debugger;
    let state = data;
    let obj = [];
    for (let a = 0; a < data.length; a++) {
      let innerobj = {
        FilePath: "",
        Name: "",
        MiniImg: "",
        poses: [],
        gender: "",
        CharacterId: "",
      };
      let gestures = JSON.parse(data[a].GesturePaths);
      if (gestures != null) {
        for (let i = 0; i < gestures.length; i++) {
          let Pobj = { poseFile: "", poseName: "", poseImg: "" };
          Pobj.poseFile = gestures[i].jsonPath;
          Pobj.poseName = gestures[i].type;
          Pobj.poseImg = gestures[i].imgPath;
          innerobj.poses.push(Pobj);
        }
      } else {
        let Pobj = { poseFile: null, poseName: null, poseImg: null };
        innerobj.poses.push(Pobj);
      }
      innerobj.MiniImg = data[a].PreviewPath;
      innerobj.FilePath = data[a].DefaultPath;
      innerobj.Name = "Default";
      if (data[a].PreviewPath.includes("Male")) {
        innerobj.gender = "Male";
      } else {
        innerobj.gender = "Female";
      }

      innerobj.CharacterId = data[a].Id;
      obj.push(innerobj);
    }

    for (let i = 0; i < state.length; i++) {
      if (state[i].id == id) {
        state[i].items = obj;
      }
    }
    setstaticCharacter(state);
  };

  const uploadref = useRef(null);

  const imageUpload = () => {
    uploadref.current.click();
  };

  const fileChangeHandle3 = (e) => {
    var formdata = new FormData();
    for (var i = 0; i < e.target.files.length; i++) {
      formdata.append("files", e.target.files[i]);
    }
    formdata.append("CategoryId", 3);

    axios
      .post(
        authenticationData.ApiBaseURL +
        "/api/Character/UploadDefaultStaticCharacter",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          let data = response.data.result;
          let state = Array.from(charcterFolder);
          let obj = [];
          for (let a = 0; a < data.length; a++) {
            let innerobj = {
              FilePath: "",
              Name: "",
              MiniImg: "",
              poses: [],
              CharacterId: "",
            };
            let gestures = JSON.parse(data[a].gesturePaths);
            if (gestures != null) {
              for (let i = 0; i < gestures.length; i++) {
                let Pobj = { poseFile: "", poseName: "", poseImg: "" };
                Pobj.poseFile = gestures[i].jsonPath;
                Pobj.poseName = gestures[i].type;
                Pobj.poseImg = gestures[i].imgPath;
                innerobj.poses.push(Pobj);
              }
            } else {
              let Pobj = { poseFile: null, poseName: null, poseImg: null };
              innerobj.poses.push(Pobj);
            }
            innerobj.MiniImg = data[a].previewPath;
            innerobj.FilePath = data[a].defaultPath;
            innerobj.Name = "Default";
            innerobj.CharacterId = data[a].id;
            obj.push(innerobj);
          }
          for (let i = 0; i < state.length; i++) {
            if (state[i].id == id) {
              state[i].items = state[i].items.concat(obj);
            }
          }
          setcharcterFolder(state);
          swal("Excellent", "Image Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Image. Please Try Again", "error");
        }
      })
      .catch((error) => {
        if (error.response) {
          swal("Failed", error.response.data, "error");
        }
      });
  };

  var staticstyle = {
    margin: "auto",
    cursor: "pointer",
    flexBasis: " 30%",
    position: "relative",
    background: "#ececec",
    borderRadius: "10px",
    color: "#000",
    marginBottom: "10px",
    display: "flex",
    alignOtems: "center",
    alignContent: "center",
    justifyContent: "center",
    transition: "opacity 0.3s linear, transform 0.3s linear, top 0.3s ease-out",
  };

  return (
    <>
      <div
        className="CharacterShow"
        style={{
          display: "inline-flex",
          width: "100%",

          justifyContent: "start",
        }}
      >
        {/* <div style={{ width: "100%", borderRadius: "6px" }}>
          <div
            style={{ borderRadius: "6px", background: "#dee8ff" }}
            onClick={show}
          >
            {
              <div className="chr_cont_name">
              
                <img
                  style={{ width: 157, height: 100, borderRadius: 5 }}
                  src={authenticationData.ApiBaseURL + "/" + path}
                />
              </div>
            }
          </div>
        </div> */}

        {ActiveTab === "Talking" && (
          <div style={{ width: "100%", padding: "0 6px 10px", fontSize: 12, color: "#5b6476", lineHeight: 1.5 }}>
            These characters move their mouth while they speak.
            {talkCheck && talkCheck.total > 0 && talkCheck.checked < talkCheck.total && (
              <div style={{ color: "#296AFF" }}>
                Finding more talking characters… {talkCheck.checked} of {talkCheck.total} checked
              </div>
            )}
            {talkCheck && talkCheck.found === 0 && talkCheck.checked >= talkCheck.total && <div>No talking characters found.</div>}
          </div>
        )}
        {/* Rendering Modern Characters only */}
        {staticCharacter.length > 0 &&
          staticCharacter.map(
            (item, index) =>
              item.CategoryId === 3 && (
                <StaticCharacter
                  catid={item.id}
                  setChrPopData={setChrPopData}
                  obj={item.items[index]}
                  PreviewPath={item.PreviewPath}
                  setchrPop={setchrPop}
                  index={index}
                  key={"StaticCharacter" + (item.items && item.items[index] ? item.items[index].CharacterId : index)}
                />
              )
          )}

        {/* Rendering Default Characters after modern */}
        {defaultCharacter.length > 0 &&
          defaultCharacter.map((item, index) => (
            <MiniCanv
              catid={item.id}
              setChrPopData={setChrPopData}
              obj={item.items[index]}
              setchrPop={setchrPop}
              index={index}
              key={"MiniCanv" + (item.items[index] && item.items[index].id ? item.items[index].id : index)}
              ActiveTab = {ActiveTab}
              onDeleted={removeUserCharacter}
            />
          ))}
        {/* Rendering Remaining Characters only */}
        {staticCharacter.length > 0 &&
          staticCharacter.map(
            (item, index) =>
              item.CategoryId !== 3 && (
                <StaticCharacter
                  catid={item.id}
                  setChrPopData={setChrPopData}
                  obj={item.items[index]}
                  PreviewPath={item.PreviewPath}
                  setchrPop={setchrPop}
                  index={index}
                  key={"StaticCharacter" + (item.items && item.items[index] ? item.items[index].CharacterId : index)}
                />
              )
          )}
      </div>


      <div className={"Character_folder_items "}>
        <div style={{ width: "100%", height: "auto" }}>
          <div className="Char_assetsList">
            {Role == "admin" && (
              <>
                <div className="image_uploader">
                  <div onClick={imageUpload} className="image_uploader_inner">
                    <div className="image_uploader_icon_container">
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 486.3 486.3"
                      >
                        <g>
                          <g>
                            <path
                              fill="#286aff"
                              d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5
                            c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16
                            C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86
                            c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69
                            c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9
                            c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6
                            c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6
                            c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"
                            />
                            <path
                              fill="#286aff"
                              d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1
                            c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5
                            C310.4,285.3,318.9,285.3,324.2,280z"
                            />
                          </g>
                          Add Subtitle
                        </g>
                       
                      </svg>
                    </div>

                    <div className="Image_uploader_text">
                      <div>Upload Character</div>
                      <input
                        ref={uploadref}
                        type="file"
                        hidden
                        multiple
                        onChange={fileChangeHandle3}
                      ></input>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* {item.length != 0 &&
                item.map((obj, index) => {
                  if (id == 0 || id == 1) {
                    return (
                      <div className="Asset_items">
                        <MiniCanv
                          setChrPopData={setChrPopData}
                          obj={obj}
                          setchrPop={setchrPop}
                          index={index}
                          key={"MiniCanv" + index}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div className="Asset_items" style={staticstyle}>
                        <StaticCharacter
                          catid={id}
                          setChrPopData={setChrPopData}
                          obj={obj}
                          setchrPop={setchrPop}
                          index={index}
                          key={"StaticCharacter" + (item.items && item.items[index] ? item.items[index].CharacterId : index)}
                        />
                      </div>
                    );
                  }
                })} */}

            {/* {id != 0 && item.length == 0 && !MyLoader && (
                <div className="Asset_items">
                  <div
                    className="Asset_items_start"
                    style={{ background: "#fff" }}
                  >
                    Coming Soon...
                  </div>
                </div>
              )} */}

            {/* {id == 0 && item.length == 0 && !MyLoader && (
                <div className="Asset_items">
                  <div
                    className="Asset_items_start"
                    style={{ background: "#fff" }}
                  >
                    No Character Added
                  </div>
                </div>
              )} */}
            {MyLoader && (
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: loader,
                }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
              />
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default AssetsCharacterWrapper;
